module.exports = __webpack_public_path__ + "static/media/call-icon.bcc98a90.svg";